import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import * as firebase from 'firebase/app'
import PostsForm from './PostsForm'
import NewsCard from './NewsCard'
import { SocialIcon } from 'react-social-icons'


class News extends Component {

  constructor () {
    super()

    this.state = {
      user: null,
      postToEdit: null,
      postToShow: null,
      showForm: false,
      showPost: false
    }

    this.editPost   = this.editPost.bind(this)
    this.showPost   = this.showPost.bind(this)
    this.backToNews = this.backToNews.bind(this)
  }

  render() {

    if ( this.state.user===null ) {
      return (
        <div className="container waitDiv">
          <div ref="waitAnimDiv" className="waitAnim"> </div>
        </div>
      )
    }
    // if user has no name in database, force to fill
    if ( this.state.user.name===undefined || this.state.user.name.trim()==='' ) {
      return (
        <div>
          <br/>
          Por favor, indica tu nombre en la sección de Configuración
          <br/>
          <Link to="/setup" style={{ fontWeight: 'bold', textDecoration: 'none', color: '#000000' }}>
            <button className='btn btn-lignht btn-sm' onClick={this.cancelEdit}>Ir a Configuración</button>
          </Link>
        </div>
      )
    }
    return (
      <div className="module">
        <div className="container moduleHeaderDiv">

            <div className="row rowDiv">
              <a href="https://www.youtube.com/c/DavidGarridoDiaz" target="_youtube_">
                <img src="youtube.png" border="0" className="socialIcon" />
              </a>
              &nbsp;&nbsp;
              <a href="https://www.facebook.com/davidgarridodiazz" target="_facebook_">
                <img src="facebook.png" border="0" className="socialIcon" />
              </a>
              &nbsp;&nbsp;
              <a href="https://www.instagram.com/david_garrido_diazz" target="_instagram_">
                <img src="instagram.png" border="0" className="socialIcon" />
              </a>
            </div>
            <br/>
            <br/>

            <div className="row rowDiv">
              <h2>Noticias</h2>
              {
                this.state.showForm===false?
                  <button className='btn btn-lignht btn-sm btnWithIcon' 
                    onClick={ () => this.addNews() }>
                    Añadir Noticia
                  </button>
                : 
                  null
                  /*
                  <button className='btn btn-lignht btn-sm btnWithIcon' 
                    onClick={ () => this.backToNews() }>
                    Cancelar
                  </button>
                  */
              }
            </div>
            
            
        </div>

        <div className="row newsDiv">

          {
            this.state.showForm===false && !this.state.showPost?
            <div className="col-md-6 centered">
              {
                this.state.posts.map ( post => {

                  let inCourse = false
                  let usesStr = ''
                  if ( post.sessions!==undefined && post.users!==undefined ) {
                    Object.keys(post.users).map ( uKey => {
                      if ( uKey === this.state.user.key ) {
                        inCourse = true
                      }
                      usesStr += post.users[uKey] + '\n'
                    })
                  }

                  return(
                    <NewsCard 
                      post={post} 
                      user={this.state.user}
                      editPost={this.editPost}
                      removePost={this.removePost}
                      showPost={this.showPost}
                      backToNews={this.backToNews}
                      showCourseInfo="false"
                      />
                  )
                })
              }
            </div>
            
            : this.state.showPost?
                <div>
                    <NewsCard 
                      post={this.state.postToShow} 
                      user={this.state.user}
                      editPost={this.editPost}
                      removePost={this.removePost}
                      showPost={this.showPost}
                      backToNews={this.backToNews}
                      showCourseInfo="true"
                      />
                </div>
            : null 
            }

          {
            this.state.showForm && this.state.user.role!=='user'?
              <div className="col-md-6 centered">
                Agregar noticia/curso
                <br/>
                <PostsForm role={this.props} postToEdit={this.state.postToEdit} backToNews={this.backToNews} />
              </div>
            : null
          }

        </div>

      </div>
    );
  }

  componentDidMount () {
    
    firebase.database().ref("posts").on ( 'value', posts => {
      let postsList = []
      posts.forEach ( post => {
        let p = post.val()
        p.key = post.key
        postsList.push(p)
      })
      this.setState({
        posts: postsList.reverse()
      })
    })

    firebase.database().ref("users").on ( 'value', users => {
      let usersList = []
      let userObj = null
      users.forEach ( user => {
        let u = user.val()
        u.key = user.key
        if (u.role==='user'){
          usersList.push(u)
        }
        if ( u.email===firebase.auth().currentUser.email){
          userObj = u
        }
      })

      this.setState({
        users: usersList,
        user: userObj
      })

    })

  }

  addNews () {
    this.setState({
      showForm: true
    })
  }

  backToNews () {
    this.setState({
      showForm: false,
      postToEdit: null,
      postToShow: null,
      showCourseInfo: false,
      showPost: false
    })
  }

  addToCourse ( postKey ) {
    firebase.database().ref("posts").child(postKey).child("users").child(this.state.user.key).set(this.state.user.name)
  }

  removeFromCourse ( postKey ) {
    firebase.database().ref("posts").child(postKey).child("users").child( this.state.user.key ).remove()
  }

  removePost ( postKey ) {
    firebase.database().ref("posts").child(postKey).remove()
  }

  editPost ( post ) {
    console.log('editPost!')
    this.setState ({
      postToEdit: post,
      showForm: true
    })
  }

  showPost ( post ) {
    console.log('showPost!')
    this.setState ({
      postToShow: post,
      showPost: true
    })
  }


}

export default News
